import { render, staticRenderFns } from "./ProductWithdraw.vue?vue&type=template&id=7683631c&scoped=true&"
import script from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ProductWithdraw.vue?vue&type=style&index=0&id=7683631c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683631c",
  null
  
)

export default component.exports